import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import {
  ConstrutosFetchModel,
  ConstrutosModel,
  TypeToAvaliacaoModel
} from '../../../../domain/models'
import {
  fetchListAllConstrutos,
  filterListAllConstrutos
} from '../../../../main/usecases'

import { goToUrl, formatDate } from '../../../utils'
import { useModalBox, useOnChangeDetect } from '../../../contexts'
import { Button, Table, EmptyData, InputFilter } from '../../../components'
import DeleteConstrutoModal from './delete-construtos'
import FilterCustomConstrutoModal from './filter-custom-construtos'

import {
  PlusSvg,
  IconEditSvg,
  IconTrashSvg
} from '../../../assets/icons/svgComponents'

import * as S from './styles'

type FilterValuesProps = {
  typeToService: string
  construto: string
}

const Construtos = () => {
  const [construtos, setConstrutos] = useState<ConstrutosFetchModel>()
  const [filterValues, setFilterValues] = useState<FilterValuesProps>()
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const history = useHistory()
  const { modalBox } = useModalBox()
  const alert = useAlert()
  const { refresh } = useOnChangeDetect()

  const handleRemoveFilterConstrutos = async () => {
    try {
      setFilterValues({ typeToService: '', construto: '' })

      const filterData = await filterListAllConstrutos({
        typeToService: '',
        construto: '',
        page: page
      }).load()

      setConstrutos(filterData)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao remover filtro', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleFilterConstrutos = async () => {
    try {
      const filterData = await filterListAllConstrutos({
        typeToService: filterValues?.typeToService || '',
        construto: filterValues?.construto || '',
        page: page
      }).load()

      setConstrutos(filterData)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao filtrar', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleClickNewClientRegister = () => {
    modalBox(<FilterCustomConstrutoModal />, 'Personalize um construto', '38%')
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Nome do construto',
        accessor: 'nameToConstruto'
      },
      {
        Header: 'Nome do serviço',
        accessor: 'nameToService'
      },
      {
        Header: 'Data de atualização',
        accessor: 'dataUltimaModificao'
      },
      {
        Header: '',
        accessor: 'actions'
      }
    ],
    []
  )

  const data = useMemo(() => {
    const handleRedirectToRegistrationData = async (
      construto: ConstrutosModel,
      typeToService: TypeToAvaliacaoModel
    ) => {
      try {
        setLoading(true)

        goToUrl(history, `/construto`, {
          cdConstruto: construto && construto.cdConstruto,
          cdTypeToService: typeToService && typeToService.cdTipoAvaliacao,
          construtoTitle: construto && construto.construto,
          serviceTitle: typeToService && typeToService.tipoAvaliacao
        })
      } catch (error) {
        console.error(error)
        alert.show('Erro ao entrar em um construto personalizado', {
          type: 'error',
          timeout: 4000
        })
      } finally {
        setLoading(false)
      }
    }

    const handleOpenDeleteModal = (
      cdTypeToService: number,
      cdConstruto: number
    ) => {
      modalBox(
        <DeleteConstrutoModal
          cdTypeToService={cdTypeToService}
          cdConstruto={cdConstruto}
        />,
        'Deletar um construto personalizado',
        '32%'
      )
    }

    return construtos?.content?.map((item) => {
      return {
        nameToConstruto: item?.construto.construto,
        nameToService: item?.tipoAvaliacao.tipoAvaliacao,
        dataUltimaModificao: formatDate(item?.dataUltimaModificacao),
        actions: (
          <div className="table-icons">
            <button
              disabled={loading}
              onClick={() =>
                handleRedirectToRegistrationData(
                  item.construto,
                  item.tipoAvaliacao
                )
              }
              title="Editar"
            >
              <IconEditSvg />
            </button>
            <div
              onClick={() =>
                handleOpenDeleteModal(
                  item.tipoAvaliacao.cdTipoAvaliacao,
                  item.construto.cdConstruto
                )
              }
            >
              <IconTrashSvg />
            </div>
          </div>
        )
      }
    })
  }, [construtos?.content, modalBox, loading, alert, history])

  useEffect(() => {
    ;(async () => {
      try {
        const data = await fetchListAllConstrutos({ page: page }).load()
        setConstrutos(data)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [page, refresh])

  return (
    <S.Wrapper>
      <S.Title>Meus construtos</S.Title>
      <S.CardContainer>
        <S.ActionsContainer>
          <Button
            initialIcon={<PlusSvg />}
            onClick={handleClickNewClientRegister}
          >
            Personalize um construto
          </Button>
          <InputFilter
            name="filter"
            type="text"
            optionsToRadio={[
              { name: 'construto', label: 'Construto' },
              { name: 'typeToService', label: 'Tipo de avaliação' }
            ]}
            placeholder="Pesquisar"
            onFilter={handleFilterConstrutos}
            onRemove={handleRemoveFilterConstrutos}
            setFilterValues={setFilterValues}
            filterValues={filterValues}
          />
        </S.ActionsContainer>
        <S.TableContainer>
          {construtos && construtos?.content?.length ? (
            <Table
              onClick={() => ({})}
              columns={columns}
              dataTable={data}
              handlePageClick={(currentPage: any) =>
                setPage(currentPage.selected + 1)
              }
              pageCount={construtos?.totalPages}
            />
          ) : construtos?.empty && construtos?.content?.length ? (
            <EmptyData>Não há nenhum construto para esse filtro</EmptyData>
          ) : (
            <EmptyData>Personalize um modelo de um construto</EmptyData>
          )}
        </S.TableContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Construtos
